// Interceptor para Keycloak - DEVE estar antes de qualquer outra importação
import './KeycloakUrlInterceptor'

import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import { SessionErrorHandler } from './app/modules/auth/components/SessionErrorHandler'
import './_metronic/assets/fonticon/fonticon.css'
import './_metronic/assets/keenicons/duotone/style.css'
import './_metronic/assets/keenicons/outline/style.css'
import './_metronic/assets/keenicons/solid/style.css'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import keycloak from './Keycloak'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
//setupAxios(axios, '')
Chart.register(...registerables)

const queryClient = new QueryClient()
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <SessionErrorHandler>
      <ReactKeycloakProvider
        initOptions={{ 
          onLoad: 'login-required',
          checkLoginIframe: false,
          checkLoginIframeInterval: 5
        }}
        authClient={keycloak}
        onEvent={(event, error) => {
          if (event === 'onAuthError') {
            console.error('[Keycloak] Auth error:', error);
          }
          if (event === 'onTokenExpired') {
            console.log('[Keycloak] Token expired, refreshing...');
            keycloak.updateToken(70);
          }
        }}
        onTokens={(tokens) => { 
          setupAxios(axios, tokens.token);
        }}
      >
        <QueryClientProvider client={queryClient}>
          <MetronicI18nProvider>
            <AuthProvider>
              <AppRoutes />
            </AuthProvider>
          </MetronicI18nProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ReactKeycloakProvider>
    </SessionErrorHandler>
  )
}
